import { PhoneNumber } from './lib/phone-number.js';
customElements.define('cipublic-phone-number', PhoneNumber);
//# sourceMappingURL=cipublic-phone-number.js.map